const EDX_BLOCK_BASE_URL = process.env.EDX_BLOCK_BASE_URL;
const REACT_H5P_SERVER_API_URL = process.env.REACT_H5P_SERVER_API_URL;

export function getH5PUrl(blockId: string, type?: string, feUrl?: string, sessionId?: string, typeQuestion?: string, viewMode?: boolean, smqsId?: string) {
    if (!type) {
        type = !blockId?.startsWith('block-') && 'h5p-content';
    }
    let url: string;

    if (type === 'h5p-content') {
        url = `${REACT_H5P_SERVER_API_URL}/play/${blockId}?user_id=anonymous`;
    } else {
        url = `${EDX_BLOCK_BASE_URL}${blockId}`;
    }

    if (feUrl) {
        const urlObj = new URL(url);

        // replace or add the `url` query param
        urlObj.searchParams.set('url', feUrl);

        url = urlObj.toString();
    }

    if (typeQuestion) {
        const urlObj = new URL(url);
        urlObj.searchParams.set('type', typeQuestion);
        url = urlObj.toString();
    }

    // smqsId = id của SubModulesQuestionSessions (lần trả lời đã lưu) — khi có, đây mới là
    // giá trị session_id đúng để H5P server tra ra và hiển thị lại đáp án học sinh đã chọn.
    // sessionId (sms_id — id phiên submodule) chỉ dùng khi câu chưa có smqsId (lazy flow).
    if (smqsId) {
        const urlObj = new URL(url);
        urlObj.searchParams.set('session_id', smqsId);
        url = urlObj.toString();
    } else {
        if (sessionId) {
            const urlObj = new URL(url);
            urlObj.searchParams.set('session_id', sessionId);
            url = urlObj.toString();
        }
        if (blockId) {
            const urlObj = new URL(url);
            urlObj.searchParams.set('block_id', blockId);
            url = urlObj.toString();
        }
    }

    if (viewMode) {
        const urlObj = new URL(url);
        urlObj.searchParams.set('view_mode', '1');
        url = urlObj.toString();
    }

    return url;
}

export function getDownloadH5PUrl(id: string) {
    return `${REACT_H5P_SERVER_API_URL}/h5p/download/${id}?user_id=anonymous`;
}